import React from 'react'
import PropTypes from 'prop-types'

import { EVENT_STATE } from '../../../utils/constants/event'

// Returns the color class for the round course availability indicator
const getAvailabilityStateColorClass = (eventState) => {
  let colorClass

  // state of course availability
  switch (eventState) {
    // enough space available
    case EVENT_STATE.EVENT_STATE_FREE:
      colorClass = 'bg-18ab42'
      break
    // almost booked out
    case EVENT_STATE.EVENT_STATE_FEW_PLACES:
    case EVENT_STATE.EVENT_STATE_BEGUN:
      colorClass = 'bg-ffc027'
      break
    // no space available/cancelled/finished
    default:
      colorClass = 'bg-eb0047'
      break
  }

  return colorClass
}

const OfferSearchState = ({ state, stateTitle, className }) => {
  const availabilityIndicatorColor = getAvailabilityStateColorClass(state)

  return (
    <p className={`text-14 leading-20 whitespace-nowrap flex items-center ${className}`}>
      {stateTitle}
      <span className={`ml-8 inline-block w-12 h-12 rounded-full ${availabilityIndicatorColor}`} />
    </p>
  )
}

OfferSearchState.propTypes = {
  state: PropTypes.number,
  stateTitle: PropTypes.string,
  className: PropTypes.string,
}

OfferSearchState.defaultProps = {
  className: '',
}

export default OfferSearchState
